import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { ConnexionComponent } from './components/connexion/connexion.component';
import { MotDePasseComponent } from './components/mot-de-passe/mot-de-passe.component';
//import { AccueilComponent } from './components/accueil/accueil.component';
import { FicheComponent } from './components/fiche/fiche.component';
import { DocumentationComponent } from './components/documentation/documentation.component';
import { ReinitialiserMotDePasseComponent } from './components/reinitialiser-mot-de-passe/reinitialiser-mot-de-passe.component';
import { HorairePointRelaisComponent } from './components/horaire-point-relais/horaire-point-relais.component';
import { FacturationComponent } from './components/facturation/facturation.component';
import { AdministrationComponent } from './components/administration/administration.component';
import { ContactComponent } from './components/contact/contact.component';

import { Erreur404Component } from './components/erreur/erreur404/erreur404.component';
import { Erreur4031Component } from './components/erreur/erreur4031/erreur4031.component';
import { Erreur4032Component } from './components/erreur/erreur4032/erreur4032.component';

import { AuthGuard } from './guards/auth.guard';
import { FournisseurGuard } from './guards/fournisseur.guard';
import { RedirectComponent } from './components/redirect/redirect.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'reinitialiser-mot-de-passe',
        component: ReinitialiserMotDePasseComponent
    },
    {
        path: 'reset-password',
        component: ReinitialiserMotDePasseComponent
    },
    {
        path: 'connexion',
        component: ConnexionComponent
    },
    {
        path: 'login',
        component: ConnexionComponent
    },
    {
        path: 'mot-de-passe',
        component: MotDePasseComponent
    },
    {
        path: 'init-password',
        component: MotDePasseComponent
    },
    {
        path: 'accueil',
        //component: AccueilComponent,
        //canActivate: [AuthGuard, FournisseurGuard]
        redirectTo: 'fiche',
        pathMatch: 'full'
    },
    {
        path: 'fiche',
        component: FicheComponent,
        canActivate: [AuthGuard, FournisseurGuard]
    },
    {
        path: 'documentation',
        component: DocumentationComponent,
        canActivate: [AuthGuard, FournisseurGuard]
    },
    {
        path: 'administration',
        component: AdministrationComponent,
        canActivate: [AuthGuard, FournisseurGuard],
        data:
        {
            role: 'Fournisseur.Administration'
        }
    },
    {
        path: 'horaires',
        component: HorairePointRelaisComponent,
        canActivate: [AuthGuard, FournisseurGuard]
    },
    {
        path: 'facturation',
        component: FacturationComponent,
        canActivate: [AuthGuard, FournisseurGuard]
    },
    {
        path: 'contact',
        component: ContactComponent,
        canActivate: [AuthGuard, FournisseurGuard]
    },
    {
        path: 'redirect',
        component: RedirectComponent
    },
    {
        path: 'erreur4031',
        component: Erreur4031Component
    },
    {
        path: 'erreur4032',
        component: Erreur4032Component
    },
    {
        path: '**',
        component: Erreur404Component
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
